type param = string | false | undefined;
export const clsx = (...args: param[]): string => args.filter((item: param) => item).join(' ');
